<template>
  <table class="contest-table table table-bordered text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th scope="col">Название</th>
        <th scope="col">Тип</th>
        <th scope="col">Аудитория</th>
        <th scope="col">Статус</th>
        <th scope="col">Начало</th>
        <th scope="col">Конец</th>
        <th scope="col">Участник конкурса</th>
      </tr>
    </thead>
    <tr
      v-for="contest in contests"
      :key="contest.id"
      :class="getContestClass(contest.status)"
    >
      <td>
        <contest-link
          :contestId="contest.id"
          label="конкурс"
        />
      </td>
      <td class="contest-type-name">
        {{ contest.type | getContestTypeName }}
      </td>
      <td>
        <span v-b-popover.hover.top="getPlayerGroupDescription(contest.playerGroupId)">
          {{ contest.playerGroupId | getPlayerGroupName }}
        </span>
      </td>
      <td :class="getContestStatusClass(contest.status)">
        {{ contest.status | getContestStatusName }}
      </td>
      <td>
        {{ contest.stime | getMomentMinStr }}
      </td>
      <td>
        {{ contest.ftime | getMomentMinStr }}
      </td>
      <td>
        <contest-player-link :contestPlayerId="createContestPlayerId(contest.id)">
          участник конкурса
        </contest-player-link>
      </td>
    </tr>
  </table>
</template>

<script>
import { getPlayerGroupName } from '../model/event.js';
import { getPlayerGroupDescription } from '../model/event.js';

import { isContestClosed       } from '../model/contest.js';
import { getContestTypeName    } from '../model/contest.js';
import { getContestStatusName  } from '../model/contest.js';
import { getContestStatusClass } from '../model/contest.js';

import ContestLink       from './ContestLink.vue';
import ContestPlayerLink from './ContestPlayerLink.vue';

export default {
  name: 'PlayerContestTable',

  components: {
    ContestLink,
    ContestPlayerLink,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    contests: {
      type: Array,
      required: true,
    },
  },

  methods: {
    getPlayerGroupDescription,
    getContestStatusClass,

    getContestClass(status) {
      return {
        closed: isContestClosed(status)
      };
    },

    /** @param {number} contestId */
    createContestPlayerId(contestId) {
      return {
        contestId: contestId,
        playerId: this.playerId,
      };
    },
  },

  filters: {
    getPlayerGroupName,
    getContestTypeName,
    getContestStatusName,
  },
}
</script>

<style scoped>
.contest-type-name {
  font-weight: bold;
}

.closed {
  color: #dcdcdc;
}

.contest-table {
  width: 1px;
}
</style>
